import Papa from 'papaparse'

const BOM = '\ufeff'
const NEWLINE = '\r\n'
const TRAILING_NEWLINES = /(?:\r\n|\r|\n)+$/

function detectDelimiter(input) {
  const sample = input.replace(TRAILING_NEWLINES, '')

  if (sample === '') {
    return undefined
  }

  return Papa.parse(sample, {
    delimiter: '',
    header: false,
    skipEmptyLines: true,
  }).meta.delimiter
}

function normalizeParsedRows(input, rows) {
  if (input === '') {
    return [['']]
  }

  const normalizedRows = [...rows]

  if (
    (input.endsWith('\n') || input.endsWith('\r')) &&
    normalizedRows.at(-1)?.length === 1 &&
    normalizedRows.at(-1)[0] === ''
  ) {
    normalizedRows.pop()
  }

  if (input.startsWith(BOM) && normalizedRows[0]?.length > 0 && !normalizedRows[0][0].startsWith(BOM)) {
    normalizedRows[0][0] = `${BOM}${normalizedRows[0][0]}`
  }

  return normalizedRows
}

function normalizeStringifyRows(input) {
  if (!Array.isArray(input)) {
    return input
  }

  if (
    input.length === 2 &&
    Array.isArray(input[0]) &&
    Array.isArray(input[1]) &&
    (input[1].length === 0 || Array.isArray(input[1][0]))
  ) {
    return [input[0], ...input[1]]
  }

  return input
}

export function parseCsv(input = '') {
  const delimiter = detectDelimiter(input)

  console.assert(
    delimiter === ',' || delimiter === '\t',
    `Unexpected delimiter "${delimiter}" detected in CSV input: ${input}`,
  )

  const rows = Papa.parse(input, {
    delimiter,
    header: false,
    skipEmptyLines: true,
  }).data

  return normalizeParsedRows(input, rows)
}

export function stringifyCsv(input) {
  const rows = normalizeStringifyRows(input)
  const output = Papa.unparse(rows, {
    header: false,
    newline: NEWLINE,
    skipEmptyLines: false,
  })

  return `${output}${NEWLINE}`
}
